<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <mat-dialog-content class="dialog-content" mat-dialog-content data-cy="prospect-dialog-content">
    @if (prospectForm?.id?.value) {
      <div class="dialog-left-content">
        <div class="left-content-header">
          <span class="infos-label">
            {{
              'Créé le'
                | atBy
                  : prospectForm.createdAt.value
                  : (prospectForm.source.value | prospectCreatedBy: prospectForm.createdBy.value)
            }}
          </span>
        </div>
        <app-prospect-company-container
          [company]="prospectForm.company.value"
          [displayNavigateToCompany]="displayNavigateToCompany()"
          [createCompanyDisabled]="!(prospectForm.contracts.value | canCreateProspectCompany)"
          [createCompanyTooltip]="prospectForm.contracts.value | createProspectCompanyTooltip"
          (navigateToCompany)="navigateToCompanyOpportunitiesInNewTab(prospectForm.company.value.id)"
          (createCompany)="createCompany()"
        ></app-prospect-company-container>
        <app-contracts-container
          [contracts]="prospectForm.contracts.value"
          (updateContract)="updateContract($event)"
          (createContract)="createContract()"
          (changeContractStatus)="changeContractStatus($event)"
        ></app-contracts-container>
      </div>
    }
    <div class="dialog-middle-content">
      <span mat-dialog-title>{{ prospectForm?.id?.value ? 'Détails' : 'Ajouter un' }} prospect</span>
      <div class="form-container">
        <app-prospect-form
          class="prospect-form"
          [prospectForm]="prospectForm"
          [civilities]="civilities$ | async"
          [legalForms]="legalForms$ | async"
          [partner]="partner$ | async"
          [businessUnits]="businessUnits$ | async"
          [acquisitionChannels]="acquisitionChannels()"
          [tiimeBusinessProAccountIntentions]="tiimeBusinessProAccountIntentions()"
        ></app-prospect-form>
        @if (!displayDuplicated()) {
          <button
            class="duplicated-users-count-action"
            tiime-button
            [color]="duplicatedLength() ? 'warn' : 'primary'"
            (click)="setDisplayDuplicated(true)"
          >
            @if (duplicatedLoading()) {
              Recherche de correspondances...
            } @else {
              {{ duplicatedWording() }}
              @if (duplicatedLength() > 0) {
                <mat-icon svgIcon="icon-warning"></mat-icon>
              } @else {
                <mat-icon svgIcon="icon-success"></mat-icon>
              }
            }
          </button>
        }
      </div>
      <div class="actions">
        <button tiime-button color="accent" strocked (click)="cancel()" data-cy="prospect-dialog-cancel-btn">
          Annuler
        </button>
        <button
          tiime-button
          color="accent"
          raised
          tiimeTooltip="La fiche de ce prospect est verrouillée car il a été lié à un dossier. Aucune modification n'est autorisée."
          [tooltipDisabled]="!prospectForm.company.value"
          [disabled]="prospectForm.disabled || prospectForm.company.value || isLoading()"
          (click)="submitProspectForm()"
          data-cy="prospect-dialog-save-btn"
        >
          {{ prospectForm?.id?.value ? 'Enregistrer' : 'Ajouter' }}
        </button>
      </div>
    </div>
    @if (displayDuplicated()) {
      <div class="dialog-right-content">
        <div class="right-content-header">
          <div class="flex gap-5 align-center">
            <button
              strocked
              tiime-button
              icon
              color="primary"
              tiimeTooltip="Fermer"
              (click)="setDisplayDuplicated(false)"
            >
              <mat-icon svgIcon="icon-right-panel-close"></mat-icon>
            </button>
            <span class="right-title">Contacts et prospects correspondants</span>
          </div>
          <button tiime-button icon color="primary" tiimeTooltip="Actualiser" (click)="refreshSearchDuplicated()">
            <mat-icon fontSet="fontastic" fontIcon="icon-synchro-1c-20"></mat-icon>
          </button>
        </div>
        @if (duplicatedLoading()) {
          <tiime-progress-spinner-loader
            diameter="60"
            color="primary"
            mode="indeterminate"
          ></tiime-progress-spinner-loader>
        } @else {
          <span class="results-label">
            <ng-container [ngPlural]="duplicatedLength()">
              <ng-template ngPluralCase="=0">Aucune correspondance n'a été identifiée</ng-template>
              <ng-template ngPluralCase="=1">1 correspondance a été identifiée</ng-template>
              <ng-template ngPluralCase="other">
                {{ duplicatedLength() }} correspondances ont été identifiées
              </ng-template>
            </ng-container>
            sur votre partenaire
          </span>
          @if (duplicatedLength() > 0) {
            <tiime-tabs>
              <tiime-tab>
                <tiime-tab-title>
                  Contacts
                  <div class="tiime-tab-label-infos">
                    <span class="tiime-tab-label-badge">{{ duplicatedUsers().length }}</span>
                  </div>
                </tiime-tab-title>
                <app-duplicated-users-container [duplicatedUsers]="duplicatedUsers()"></app-duplicated-users-container>
              </tiime-tab>
              <tiime-tab>
                <tiime-tab-title>
                  Prospects
                  <div class="tiime-tab-label-infos">
                    <span class="tiime-tab-label-badge">{{ duplicatedProspects().length }}</span>
                  </div>
                </tiime-tab-title>
                <app-duplicated-prospects-container
                  [duplicatedProspects]="duplicatedProspects()"
                ></app-duplicated-prospects-container>
              </tiime-tab>
            </tiime-tabs>
          }
        }
      </div>
    }
  </mat-dialog-content>
</tiime-dialog>
